import { putCoreBusinessContextUploadSlice } from './put';

export const { requestPutCoreBusinessContextUpload, resetPutCoreBusinessContextUpload } =
	putCoreBusinessContextUploadSlice.asyncActionCreators;
